/*
 * Pure Tea – Custom JavaScript (HMXNETWORK)
 * Ausgelagert bei der Migration Sleek 1.8.0 -> 2.3.0 am 2026-09-09.
 * Enthält unverändert:
 *   Block 1: theme.js (1.8.0) Zeilen 1061-2466  – Mengen-Dropdown <quantity-input> v3.7.7 (ersetzt Vendor-QuantityInput)
 *   Block 2: theme.js (1.8.0) Zeilen 3775-4646  – Add-ons (Teegarten-Link, Typ-Klassen, Interceptor, Cookiebot-Reload, Fixes)
 *   Cart-Drawer-Hooks (vormals cart.js CartDrawer-Klasse)
 *   Block 3: cart.js (1.8.0) Zeilen 714-1029    – Versandkosten-Rechner, formatMoneyUnified, FoxKitAddToCart-Override
 * Wird in layout/theme.liquid am Ende von <body> mit defer geladen, damit theme.js und cart.js bereits ausgeführt sind.
 * Voraussetzung: in assets/theme.js ist die Vendor-Klasse QuantityInput entfernt (sonst greift der Guard in Block 1 nicht).
 */
/* ############################################################################################################## */
// QUANTITY DROPDOWN - VERSION 3.7.7 - SPECIAL TEA STÜCK-ANZEIGE

window.addEventListener('DOMContentLoaded', () => {
  const SCRIPT_VERSION = '3.7.7';
  
  // Warte bis FoxTheme geladen ist
  const waitForFoxTheme = (callback, maxAttempts = 50) => {
    let attempts = 0;
    const checkInterval = setInterval(() => {
      attempts++;
      if (typeof FoxTheme !== 'undefined' && FoxTheme.pubsub) {
        clearInterval(checkInterval);
        callback();
      } else if (attempts >= maxAttempts) {
        clearInterval(checkInterval);
        console.warn('⚠️ FoxTheme nicht gefunden - läuft im Standalone-Modus');
        window.FoxTheme = {
          pubsub: {
            subscribe: () => () => {},
            PUB_SUB_EVENTS: {
              quantityUpdate: 'quantityUpdate',
              quantityBoundries: 'quantityBoundries',
              quantityRules: 'quantityRules',
              variantChange: 'variantChange'
            }
          }
        };
        callback();
      }
    }, 100);
  };

  waitForFoxTheme(() => {
    class QuantityInputDropdown extends HTMLElement {
      quantityUpdateUnsubscriber = undefined;
      quantityBoundriesUnsubscriber = undefined;
      quantityRulesUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;
      discountyObserver = undefined;

      constructor() {
        super();
        this.version = SCRIPT_VERSION;
     
        this.discountLevels = {
          3: 5,   // 5% Rabatt
          5: 10   // 10% Rabatt
        };
        this.isInitialized = false;
        this.weightElement = null;
        this.isCartDrawer = false;
        this.hasVolumeDiscount = false;
        this.originalUnitPrice = null;
        this.unitPriceProtected = false;
        this.variantId = null;
        this.isSampleSet = false; // NEU: Probensortiment Flag
        this._isSpecialTea = null; // NEU: Cache für Special Tea Check
        
        // Verbesserte Referenzen
        this.instanceId = `qty-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
        this.myCartItem = null;
        this.myLineIndex = null;
        this.myInput = null;
        this.myQuantity = '1';
        
        // Event-Sturm Prevention
        this.isUpdating = false;
        this.updateQueue = null;
        this.cartUpdateQueue = null;
        this.priceFixQueue = null;
        
        // Change Detection
        this.lastProcessedQuantity = null;
        this.lastProcessedDiscount = null;
      }

      get sectionId() {
        return this.getAttribute('data-section-id');
      }

      get productId() {
        return this.getAttribute('data-product-id');
      }

      get input() {
        if (this.myInput && document.contains(this.myInput)) {
          return this.myInput;
        }
        this.myInput = this.querySelector('input[type="number"]');
        return this.myInput;
      }

      get value() {
        const input = this.input;
        if (input && input.value) {
          this.myQuantity = input.value;
          return input.value;
        }
        return this.myQuantity;
      }

      // NEU: Prüft ob Produkt zur Special Tea Collection gehört
      isSpecialTea() {
        // Cache nutzen wenn bereits geprüft
        if (this._isSpecialTea !== null) {
          return this._isSpecialTea;
        }
        
        // Cart Drawer: Prüfe CSS-Klasse am Cart-Item
        if (this.isCartDrawer && this.myCartItem) {
          this._isSpecialTea = this.myCartItem.classList.contains('tag-bio-tee-special-edition');
          return this._isSpecialTea;
        }
        
        // Produktseite: Prüfe CSS-Klasse am Body
        if (!this.isCartDrawer) {
          this._isSpecialTea = document.body.classList.contains('special-tea');
          return this._isSpecialTea;
        }
        
        this._isSpecialTea = false;
        return this._isSpecialTea;
      }

      connectedCallback() {
        if (this.isInitialized) return;
        this.isInitialized = true;
        
        this.setAttribute('data-instance-id', this.instanceId);
        
        this.abortController = new AbortController();
        this.changeEvent = new Event('change', { bubbles: true });
        
        this.isCartDrawer = !!(this.closest('.cart-drawer') || this.closest('.cart-items'));
        const isProductPage = !!this.closest('.product-form__buttons');
        
        if (this.isCartDrawer) {
          this.bindToCartItem();
          this.initializeCartDrawerAsync();
        } else {
          this.checkVolumeDiscount();
          this.initializeDropdown();
        }
        
        this.validateQtyRules();

        if (typeof FoxTheme !== 'undefined' && FoxTheme.pubsub) {
          this.quantityUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
            FoxTheme.pubsub.PUB_SUB_EVENTS.quantityUpdate,
            this.validateQtyRules.bind(this)
          );
          this.quantityBoundriesUnsubscriber = FoxTheme.pubsub.subscribe(
            FoxTheme.pubsub.PUB_SUB_EVENTS.quantityBoundries,
            this.setQuantityBoundries.bind(this)
          );
          this.quantityRulesUnsubscriber = FoxTheme.pubsub.subscribe(
            FoxTheme.pubsub.PUB_SUB_EVENTS.quantityRules,
            this.updateQuantityRules.bind(this)
          );
          
          this.variantChangeUnsubscriber = FoxTheme.pubsub.subscribe(
            FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange || 'variantChange',
            this.handleVariantChange.bind(this)
          );
        }

        document.addEventListener('priceFormatUpdate', (event) => {
          if (event.detail.source === 'cart-shipping-calculator') {
            clearTimeout(this.priceFixQueue);
            this.priceFixQueue = setTimeout(() => {
              if (!this.isUpdating) {
                this.updateMyCartItem();
                if (this.hasVolumeDiscount) {
                  this.updateCartUnitPrice();
                }
              }
            }, 100);
          }
        });

        this.currentValue = this.value;
        
        if (isProductPage) {
          setTimeout(() => {
            this.setupProductPage();
            this.setupVariantListener();
          }, 300);
        }
        
        if (this.isCartDrawer) {
          document.addEventListener('cart:updated', (event) => {
            this.handleCartUpdatedIsolated(event);
          }, { signal: this.abortController.signal });
            
          this.setupUnitPriceProtection();
        }
      }

      bindToCartItem() {
        const cartItem = this.closest('.cart-item, .cart-drawer-item, li[id*="CartDrawer-Item"]');
        if (!cartItem) {
          console.error(`❌ VERSION ${this.version} - Kein Cart-Item gefunden für Instance ${this.instanceId}`);
          return;
        }
        
        this.myCartItem = cartItem;
        cartItem.setAttribute('data-qty-instance', this.instanceId);
        
        this.variantId = cartItem.dataset.variantId || 
                        cartItem.getAttribute('data-variant-id') || 
                        cartItem.querySelector('[data-variant-id]')?.dataset.variantId || 
                        '';
        
        const cartQuantity = cartItem.dataset.quantity || cartItem.getAttribute('data-quantity') || '1';
        this.myQuantity = cartQuantity;
        
        // NEU: Prüfe ob Probensortiment
        this.isSampleSet = cartItem.getAttribute('data-is-sample-set') === 'true' ||
                          cartItem.dataset.isSampleSet === 'true' ||
                          (cartItem.dataset.handle && cartItem.dataset.handle.includes('probensortiment'));
        
        // NEU: Special Tea Check nach bindToCartItem (myCartItem ist jetzt gesetzt)
        this._isSpecialTea = null; // Cache zurücksetzen
        this.isSpecialTea(); // Neu prüfen und cachen

        const existingInput = this.querySelector('input[type="number"]');
        if (existingInput) {
          existingInput.value = this.myQuantity;
          this.myInput = existingInput;
          existingInput.setAttribute('data-instance', this.instanceId);
        }
        
        const removeButton = cartItem.querySelector('[data-index]');
        if (removeButton) {
          this.myLineIndex = removeButton.dataset.index;
        } else if (cartItem.id) {
          const match = cartItem.id.match(/Item-(\d+)$/);
          if (match) {
            this.myLineIndex = match[1];
          }
        }
      }

      async initializeCartDrawerAsync() {

        await this.checkVolumeDiscountInCart();
 
        // NEU: Bei Probensortiment KEIN Dropdown erstellen
        if (!this.isSampleSet) {
          this.initializeDropdown();
        }
        
        this.extractOriginalUnitPrice();
        this.extractWeightFromCart();
        
        setTimeout(() => {
          this.setupCartDrawer();
          this.updateMyCartItem();
        }, 100);
        
        setTimeout(() => {
          if (!this.isSampleSet) {
            this.setupDiscountyWatcher();
          }
        }, 200);
        
        setTimeout(async () => {
          const oldHasDiscount = this.hasVolumeDiscount;
          await this.checkVolumeDiscountInCart();
          
          if (oldHasDiscount !== this.hasVolumeDiscount && !this.isSampleSet) {
            this.rebuildDropdownWithDiscounts();
            this.updateMyCartItem();
          }
        }, 500);
      }

      async checkVolumeDiscountInCart() {
        if (!this.myCartItem) return;

        let hasRabattBadge = false;
        
        if (this.variantId) {
          try {
            const response = await fetch('/cart.js');
            const cart = await response.json();
            const cartItem = cart.items.find(item => item.variant_id == this.variantId);
            
            if (cartItem) {
              if (cartItem.properties && cartItem.properties._volume_discount === 'true') {
                hasRabattBadge = true;
              }
              
              if (!hasRabattBadge && cartItem.product_id) {
                const hiddenEl = document.querySelector(`#volume-discount-${cartItem.product_id}`);
                if (hiddenEl?.dataset.hasVolumeDiscount === 'true') {
                  hasRabattBadge = true;
                }
              }
            }
          } catch (error) {
            console.warn('⚠️ Cart API Fehler:', error);
          }
        }
        
        if (!hasRabattBadge) {
          const discountElements = this.myCartItem.querySelectorAll('.discount, .cart-item__discount');
          if (discountElements.length > 0) {
            hasRabattBadge = true;
          }
        }
        
        if (!hasRabattBadge) {
          const badges = this.myCartItem.querySelectorAll('.badge, .mengenrabatt-text');
          for (let badge of badges) {
            if (badge.textContent.includes('Rabatt') || badge.textContent.includes('%')) {
              hasRabattBadge = true;
              break;
            }
          }
        }
        
        this.hasVolumeDiscount = hasRabattBadge;
        
      }

      setupDiscountyWatcher() {
        if (!this.myCartItem) return;

        const discountContainer = this.myCartItem.querySelector('.cart-item__discounts, .discounts');
        const observeTarget = discountContainer || this.myCartItem;
        
        this.discountyObserver = new MutationObserver((mutations) => {
          if (this.isUpdating) return;
          
          const relevantMutations = mutations.filter(mutation => {
            if (mutation.target.textContent?.includes('Mengenrabatt Produkt')) {
              return false;
            }
            
            if (mutation.target.classList?.contains('unit-price')) {
              return false;
            }
            
            return true;
          });
          
          if (relevantMutations.length === 0) return;
          
          let discountChanged = false;
          
          relevantMutations.forEach((mutation) => {
            if (mutation.type === 'childList') {
              const addedNodes = Array.from(mutation.addedNodes);
              const hasDiscountElements = addedNodes.some(node => {
                if (node.nodeType === 1) {
                  return node.classList?.contains('discount') || 
                         node.classList?.contains('cart-item__discounts');
                }
                return false;
              });
              
              if (hasDiscountElements) {
                discountChanged = true;
              }
            }
          });
          
          if (discountChanged) {
            clearTimeout(this.updateQueue);
            this.updateQueue = setTimeout(() => {
              if (this.isUpdating) return;
              
              const oldHasDiscount = this.hasVolumeDiscount;
              this.checkVolumeDiscountInCart();
              
              if (oldHasDiscount !== this.hasVolumeDiscount) {
                this.rebuildDropdownWithDiscounts();
                this.updateMyCartItem();
              }
            }, 250);
          }
        });
        
        this.discountyObserver.observe(observeTarget, {
          childList: true,
          subtree: discountContainer ? false : true
        });
      }

      rebuildDropdownWithDiscounts() {
        const existingDropdown = this.querySelector('.quantity-dropdown-container');
        if (!existingDropdown) return;
   
        existingDropdown.remove();
        this.initializeDropdown();
      }

      disconnectedCallback() {
        if (this.myCartItem) {
          this.myCartItem.removeAttribute('data-qty-instance');
        }
        
        if (this.abortController) {
          this.abortController.abort();
        }

        clearTimeout(this.updateQueue);
        clearTimeout(this.cartUpdateQueue);
        clearTimeout(this.priceFixQueue);

        if (this.quantityUpdateUnsubscriber) {
          this.quantityUpdateUnsubscriber();
        }
        if (this.quantityBoundriesUnsubscriber) {
          this.quantityBoundriesUnsubscriber();
        }
        if (this.quantityRulesUnsubscriber) {
          this.quantityRulesUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
        
        if (this.priceObserver) {
          this.priceObserver.disconnect();
        }
        
        if (this.unitPriceObserver) {
          this.unitPriceObserver.disconnect();
        }
        
        if (this.discountyObserver) {
          this.discountyObserver.disconnect();
          this.discountyObserver = null;
        }
      }
      
      setupUnitPriceProtection() {
        return;
      }
      
      extractOriginalUnitPrice() {
        if (!this.myCartItem) return;
        
        const unitPriceEl = this.myCartItem.querySelector('.unit-price');
        if (unitPriceEl) {
          const cleanText = unitPriceEl.textContent.replace(/-\d+%/g, '').trim();
          const match = cleanText.match(/€?([\d,]+)/);
          if (match) {
            this.originalUnitPrice = parseFloat(match[1].replace(',', '.'));
          }
        }
      }
      
      extractWeightFromCart() {
        if (!this.myCartItem) return;

        const unitPriceEl = this.myCartItem.querySelector('.unit-price');
        const priceEl = this.myCartItem.querySelector('.price:not(.unit-price)');
        
        if (unitPriceEl && priceEl) {
          const unitMatch = unitPriceEl.textContent.match(/€?([\d,]+)/);
          const priceMatch = priceEl.textContent.match(/€?([\d,]+)/);
          
          if (unitMatch && priceMatch) {
            const unitPricePerKg = parseFloat(unitMatch[1].replace(',', '.'));
            const itemPrice = parseFloat(priceMatch[1].replace(',', '.'));
            
            const weightInGrams = Math.round((itemPrice / unitPricePerKg) * 1000);
            
            if (weightInGrams > 0 && weightInGrams < 10000) {
              if (weightInGrams >= 1000) {
                const kg = weightInGrams / 1000;
                this.cartWeight = `${kg} kg`;
              } else {
                this.cartWeight = `${weightInGrams} g`;
              }
              return;
            }
          }
        }
        
        if (this.variantId) {
          fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
              const item = cart.items.find(i => i.variant_id == this.variantId);
              if (item && item.grams) {
                const grams = item.grams;
                if (grams >= 1000) {
                  this.cartWeight = `${grams / 1000} kg`;
                } else {
                  this.cartWeight = `${grams} g`;
                }
                
                if (this.weightElement) {
                  this.weightElement.textContent = `× ${this.cartWeight}`;
                }
              }
            })
            .catch(e => console.warn('Cart API nicht verfügbar:', e));
        }
        
        this.cartWeight = '100 g';
      }
      
      handleCartUpdatedIsolated(event) {
        if (this.isUpdating) {
          return;
        }
        
        if (!this.myCartItem || !document.contains(this.myCartItem)) {
          const newCartItem = document.querySelector(`[data-qty-instance="${this.instanceId}"]`);
          if (newCartItem) {
            this.myCartItem = newCartItem;

            const newInput = this.querySelector('input[type="number"]');
            if (newInput) {
              this.myInput = newInput;
              newInput.value = this.myQuantity;
            }
          } else {
            return;
          }
        }
        
        clearTimeout(this.cartUpdateQueue);
        this.cartUpdateQueue = setTimeout(() => {
          if (!this.isUpdating) {
            this.updateMyCartItem();
          }
        }, 100);
      }
      
      updateMyCartItem() {
        if (!this.myCartItem) return;
        
        const currentInput = this.input;
        if (currentInput) {
          this.myQuantity = currentInput.value;
        }
        
        if (this.lastProcessedQuantity === this.myQuantity && 
            this.lastProcessedDiscount === this.hasVolumeDiscount) {
          return;
        }
        
        if (this.isUpdating) {
          return;
        }
        
        this.isUpdating = true;
        
        const observerWasConnected = !!this.discountyObserver;
        if (observerWasConnected) {
          this.discountyObserver.disconnect();
        }
        
        try {

          this.updateCartBadge();
          
          if (this.hasVolumeDiscount && this.originalUnitPrice) {
            this.updateCartUnitPrice();
          }
          
          this.lastProcessedQuantity = this.myQuantity;
          this.lastProcessedDiscount = this.hasVolumeDiscount;
          
        } finally {
          setTimeout(() => {
            this.isUpdating = false;
            
            if (observerWasConnected && this.discountyObserver && this.myCartItem) {
              const discountContainer = this.myCartItem.querySelector('.cart-item__discounts, .discounts');
              const observeTarget = discountContainer || this.myCartItem;
              
              this.discountyObserver.observe(observeTarget, {
                childList: true,
                subtree: discountContainer ? false : true
              });
            }
          }, 200);
        }
      }
      
      updateCartUnitPrice() {
        if (!this.myCartItem) return;
        
        const unitPriceEl = this.myCartItem.querySelector('.unit-price');
        if (!unitPriceEl || !this.originalUnitPrice) return;
        
        const quantity = parseInt(this.myQuantity);
        
        let discount = 0;
        if (this.hasVolumeDiscount) {
          if (quantity >= 5) {
            discount = 10;
          } else if (quantity >= 3) {
            discount = 5;
          }
        }
        
        let rabattBadge = null;
        const allElements = this.myCartItem.querySelectorAll('*');
        for (let elem of allElements) {
          const text = elem.textContent.trim();
          if (text.startsWith('Mengenrabatt Produkt') && elem.children.length === 0) {
            rabattBadge = elem;
            break;
          }
        }
        
        if (rabattBadge && this.hasVolumeDiscount) {
          if (discount > 0) {
            rabattBadge.textContent = `Mengenrabatt Produkt ${discount} %`;
            rabattBadge.style.display = '';
            rabattBadge.style.opacity = '1';
          } else {
            rabattBadge.style.display = 'none';
          }
        }
        
        this.unitPriceProtected = true;
        
        if (discount > 0 && this.hasVolumeDiscount) {
          const discountedPrice = this.originalUnitPrice * (1 - discount / 100);
          const formatted = window.formatMoneyUnified ? 
            window.formatMoneyUnified(Math.round(discountedPrice * 100)) :
            `${discountedPrice.toFixed(2).replace('.', ',')} €`;
          unitPriceEl.innerHTML = `(${formatted}/kg)`;
        } else {
          const formatted = window.formatMoneyUnified ? 
            window.formatMoneyUnified(Math.round(this.originalUnitPrice * 100)) :
            `${this.originalUnitPrice.toFixed(2).replace('.', ',')} €`;
          unitPriceEl.innerHTML = `(${formatted}/kg)`;
        }
        
        setTimeout(() => {
          this.unitPriceProtected = false;
        }, 100);
      }

      getVariantWeight() {
        // NEU: Special Tea zeigt "Stück" statt Gewicht
        if (this.isSpecialTea()) {
          return 'Stück';
        }
        
        if (this.isCartDrawer && this.cartWeight) {
          return this.cartWeight;
        }
        
        let currentVariantId = null;
        const variantInput = document.querySelector('input[name="id"]:checked, input[name="id"], select[name="id"]');
        
        if (variantInput) {
          if (variantInput.tagName === 'SELECT') {
            currentVariantId = parseInt(variantInput.value);
          } else if (variantInput.type === 'radio') {
            currentVariantId = parseInt(variantInput.value);
          } else if (variantInput.type === 'hidden') {
            currentVariantId = parseInt(variantInput.value);
          }
        }

        const scripts = document.querySelectorAll('script[type="application/json"]');
        let allVariants = [];
        
        for (let script of scripts) {
          try {
            const data = JSON.parse(script.textContent);
            
            if (data.variants && Array.isArray(data.variants) && data.variants.length > 0) {
              allVariants = data.variants;
              break;
            }
          } catch (e) {
            // Ignoriere Parse-Fehler
          }
        }
        
        let variantData = null;
        
        if (currentVariantId && allVariants.length > 0) {
          variantData = allVariants.find(v => v.id === currentVariantId);
        }
        
        if (!variantData && allVariants.length > 0) {
          variantData = allVariants[0];
        }
        
        if (variantData) {
          const weight = variantData.weight;
          const weightUnit = variantData.weight_unit;
          
          if (weight && weightUnit) {
            if (weightUnit === 'g' && weight >= 1000) {
              const kg = weight / 1000;
              const result = `${kg} kg`;
              return result;
            }
            
            let result;
            if (weight % 1 === 0) {
              result = `${Math.round(weight)} ${weightUnit}`;
            } else {
              result = `${weight} ${weightUnit}`;
            }
            return result;
          }
        }
        
        console.warn('⚠️ Kein Gewicht gefunden - verwende Fallback');
        return '100 g';
      }

      updateWeight() {
        if (!this.weightElement) return;
        
        const weight = this.getVariantWeight();
        // Bei Special Tea nur "Stück", sonst "× Gewicht"
        this.weightElement.textContent = this.isSpecialTea() ? weight : `× ${weight}`;
      }

      handleVariantChange(data) {
        if (this.isCartDrawer) return;

        setTimeout(() => {
          this.checkVolumeDiscount();
          this.updateWeight();
          this.updatePriceDisplay();
        }, 100);
      }

      setupVariantListener() {
        if (this.isCartDrawer) return;

        const variantInputs = document.querySelectorAll('input[name="id"], select[name="id"]');
        variantInputs.forEach(input => {
          input.addEventListener('change', () => {
            setTimeout(() => {
              this.updateWeight();
              this.checkVolumeDiscount();
              this.updatePriceDisplay();
            }, 50);
          }, { signal: this.abortController.signal });
        });
        
        const variantPicker = document.querySelector('.variant-picker, [data-variant-picker]');
        if (variantPicker) {
          variantPicker.addEventListener('change', () => {
            setTimeout(() => {
              this.updateWeight();
              this.checkVolumeDiscount();
              this.updatePriceDisplay();
            }, 50);
          }, { signal: this.abortController.signal });
        }
        
        const hiddenInput = document.querySelector('input[type="hidden"][name="id"]');
        if (hiddenInput) {
          const observer = new MutationObserver(() => {
            setTimeout(() => {
              this.updateWeight();
              this.checkVolumeDiscount();
              this.updatePriceDisplay();
            }, 50);
          });
          
          observer.observe(hiddenInput, {
            attributes: true,
            attributeFilter: ['value']
          });
        }
      }

      initializeDropdown() {
        const buttons = this.querySelectorAll('button');
        const originalInput = this.input;
        
        if (!originalInput) {
          console.error(`❌ VERSION ${this.version} - Kein Input gefunden!`);
          return;
        }
        
        buttons.forEach(btn => btn.style.display = 'none');
        originalInput.style.display = 'none';
        
        const dropdownContainer = document.createElement('div');
        dropdownContainer.className = 'quantity-dropdown-container';
        dropdownContainer.style.cssText = `
          position: relative;
          min-width: 80px;
          display: inline-block;
        `;
        
        this.selectedDisplay = document.createElement('button');
        this.selectedDisplay.type = 'button';
        this.selectedDisplay.className = 'quantity-dropdown-toggle';
        this.selectedDisplay.setAttribute('aria-expanded', 'false');
        this.selectedDisplay.style.cssText = `
          width: 100%;
          padding: 10px 35px 10px 15px;
          border: 1px solid #d4d4d4;
          background: white;
          font-size: 16px;
          font-weight: 500;
          text-align: left;
          cursor: pointer;
          position: relative;
          border-radius: 4px;
          transition: border-color 0.2s;
          display: block;
        `;
        
        const valueSpan = document.createElement('span');
        valueSpan.className = 'quantity-value';
        valueSpan.textContent = originalInput.value;
        
        const arrowSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        arrowSvg.setAttribute('viewBox', '0 0 12 12');
        arrowSvg.style.cssText = `
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translateY(-50%);
          width: 10px;
          height: 10px;
          pointer-events: none;
        `;
        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', 'M6 9L1 4h10L6 9z');
        path.setAttribute('fill', 'currentColor');
        arrowSvg.appendChild(path);
        
        this.selectedDisplay.appendChild(valueSpan);
        this.selectedDisplay.appendChild(arrowSvg);
        
        this.dropdownList = document.createElement('div');
        this.dropdownList.className = 'quantity-dropdown-list';
        this.dropdownList.style.cssText = `
          position: absolute;
          top: 100%;
          left: 0;
          min-width: 140px;
          background: white;
          border: 1px solid #d4d4d4;
          border-radius: 4px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
          display: none;
          max-height: 300px;
          overflow-y: auto;
          margin-top: 4px;
          z-index: 2147483647 !important;
        `;
        
        const min = parseInt(originalInput.min) || 1;
        const max = 20;
        
        for (let i = min; i <= max; i++) {
          const option = document.createElement('div');
          option.className = 'quantity-option';
          option.setAttribute('role', 'button'); // Pure Tea Migration 2.3.0: Touch-Klick (siehe touchend-Handler in theme.js)
          option.dataset.value = i;
          option.style.cssText = `
            padding: 8px 12px;
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            align-items: center;
            transition: background-color 0.2s;
            min-width: 120px;
          `;
          
          const numberSpan = document.createElement('span');
          numberSpan.style.fontSize = '14px';
          numberSpan.textContent = i;
          option.appendChild(numberSpan);
          
          if (this.hasVolumeDiscount && (i === 3 || i === 5)) {
            let discount = 0;
            if (i >= 5) discount = 10;
            else if (i >= 3) discount = 5;
            
            if (discount > 0) {
              const discountSpan = document.createElement('span');
              discountSpan.style.cssText = `
                color: #ff6b35;
                font-weight: bold;
                font-size: 12px;
                margin-left: 15px;
              `;
              discountSpan.textContent = `-${discount}%`;
              option.appendChild(discountSpan);
            }
          }
          
          option.addEventListener('mouseenter', () => {
            option.style.backgroundColor = '#f5f5f5';
          });
          
          option.addEventListener('mouseleave', () => {
            option.style.backgroundColor = '';
          });
          
          option.addEventListener('click', (e) => {
            e.stopPropagation();
            this.selectQuantity(i);
          });
          
          this.dropdownList.appendChild(option);
        }
        
        dropdownContainer.appendChild(this.selectedDisplay);
        dropdownContainer.appendChild(this.dropdownList);
        
        this.insertBefore(dropdownContainer, this.firstElementChild);
        
        this.selectedDisplay.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.toggleDropdown();
        });
        
        const closeHandler = (e) => {
          if (!dropdownContainer.contains(e.target)) {
            this.closeDropdown();
          }
        };
        document.addEventListener('click', closeHandler, { signal: this.abortController.signal });
        
        originalInput.addEventListener('change', () => {
          valueSpan.textContent = originalInput.value;
          this.updatePriceDisplay();
        });
      }
      
      toggleDropdown() {
        const isOpen = this.dropdownList.style.display === 'block';
        if (isOpen) {
          this.closeDropdown();
        } else {
          this.openDropdown();
        }
      }
      
      openDropdown() {
        this.dropdownList.style.display = 'block';
        this.selectedDisplay.setAttribute('aria-expanded', 'true');
        
        const rect = this.selectedDisplay.getBoundingClientRect();
        this.dropdownList.style.position = 'fixed';
        this.dropdownList.style.top = `${rect.bottom + 4}px`;
        this.dropdownList.style.left = `${rect.left}px`;
        this.dropdownList.style.zIndex = '2147483647';
        document.body.appendChild(this.dropdownList);
      }
      
      closeDropdown() {
        this.dropdownList.style.display = 'none';
        this.selectedDisplay.setAttribute('aria-expanded', 'false');
        
        const container = this.querySelector('.quantity-dropdown-container');
        if (container && this.dropdownList.parentElement === document.body) {
          this.dropdownList.style.position = 'absolute';
          this.dropdownList.style.top = '100%';
          this.dropdownList.style.left = '0';
          container.appendChild(this.dropdownList);
        }
      }
      
      selectQuantity(value) {
        const input = this.querySelector('input[type="number"]');
        if (!input) return;
        
        const oldValue = input.value;
        input.value = value;
        this.myQuantity = value;
        
        const valueDisplay = this.querySelector('.quantity-value');
        if (valueDisplay) {
          valueDisplay.textContent = value;
        }
        
        if (this.weightElement) {
          this.updateWeight();
        }
        
        this.closeDropdown();
        this.updatePriceDisplay();
        input.dispatchEvent(this.changeEvent);
        
        if (this.isCartDrawer) {
          this.updateMyCartItem();
          
          if (oldValue !== value) {
            this.updateCartItemNative(value);
          }
        }
      }
      
      updateCartItemNative(newQuantity) {
        const cartItems = document.querySelector('cart-items');
        if (!cartItems || !this.myLineIndex) return;
        
        if (typeof cartItems.updateQuantity === 'function') {
          const targetElement = this.querySelector('input[type="number"]');
          cartItems.updateQuantity(this.myLineIndex, newQuantity, 'quantity', targetElement);
        }
      }
      
      setupProductPage() {
        const existingDropdown = this.querySelector('.quantity-dropdown-container');
        if (!existingDropdown) return;
        
        existingDropdown.remove();
        this.innerHTML = '';
        
        const wrapper = document.createElement('div');
        wrapper.style.cssText = `
          display: inline-flex;
          align-items: center;
          gap: 10px;
        `;
        
        wrapper.appendChild(existingDropdown);
        
        const weightSpan = document.createElement('span');
        weightSpan.className = 'quantity-weight-text';
        weightSpan.style.cssText = `
          font-size: 16px;
          font-weight: 500;
          color: #333;
        `;
        const weight = this.getVariantWeight();
        // Bei Special Tea nur "Stück", sonst "× Gewicht"
        weightSpan.textContent = this.isSpecialTea() ? weight : `× ${weight}`;
        wrapper.appendChild(weightSpan);
        
        this.weightElement = weightSpan;
        this.appendChild(wrapper);
        
        const hiddenInput = document.createElement('input');
        hiddenInput.type = 'number';
        hiddenInput.name = 'quantity';
        hiddenInput.value = '1';
        hiddenInput.min = '1';
        hiddenInput.style.display = 'none';
        hiddenInput.className = 'quantity__input';
        this.appendChild(hiddenInput);
        
        const priceBlock = document.querySelector('.product__block--price');
        if (priceBlock) {
          const priceElement = priceBlock.querySelector('.f-price-item--regular');
          if (priceElement) {
            const match = priceElement.textContent.match(/€?([\d,]+)/);
            if (match) {
              this.basePrice = parseFloat(match[1].replace(',', '.'));
            }
            this.originalPriceElement = priceElement;
            this.originalPriceHTML = priceElement.innerHTML;
          }
          
          const unitPriceElement = priceBlock.querySelector('.f-price__unit span[data-unit-price]');
          if (unitPriceElement) {
            const unitMatch = unitPriceElement.textContent.match(/€?([\d,]+)/);
            if (unitMatch) {
              this.basePricePerKg = parseFloat(unitMatch[1].replace(',', '.'));
            }
            this.originalUnitPriceElement = unitPriceElement;
            this.originalUnitPriceHTML = unitPriceElement.innerHTML;
          }
        }
      }
      
      setupCartDrawer() {

  if (this.classList.contains('hide-quantity-selector')) {

    // Nur Hidden Input für Shopify erstellen
    const hiddenInput = document.createElement('input');
    hiddenInput.type = 'number';
    hiddenInput.name = 'quantity';
    hiddenInput.value = this.myQuantity;
    hiddenInput.min = '1';
    hiddenInput.style.display = 'none';
    hiddenInput.className = 'quantity__input';
    hiddenInput.setAttribute('data-instance', this.instanceId);
    this.appendChild(hiddenInput);
    this.myInput = hiddenInput;
    
    return; // Fertig - kein Dropdown nötig
  }
  
  const existingDropdown = this.querySelector('.quantity-dropdown-container');
  if (!existingDropdown) {
    return;
  }
  
  existingDropdown.remove();
  this.innerHTML = '';
  
  const wrapper = document.createElement('div');
  wrapper.className = 'cart-quantity-wrapper';
  wrapper.style.cssText = `
    display: inline-flex;
    align-items: center;
    gap: 8px;
  `;
  
  wrapper.appendChild(existingDropdown);
  
  // GUTSCHEIN-PRÜFUNG
  const attr1 = this.myCartItem?.getAttribute('data-is-gift-card');
  const attr2 = this.myCartItem?.dataset?.isGiftCard;
  const handle = this.myCartItem?.dataset?.handle;
  const handleCheck = handle?.includes('gutschein');
  const check1 = attr1 === 'true';
  const check2 = attr2 === 'true';
  const isGiftCard = check1 || check2 || handleCheck;

  if (!isGiftCard) {
    const weightSpan = document.createElement('span');
    weightSpan.className = 'cart-weight-text';
    weightSpan.style.cssText = `
      font-size: 14px;
      font-weight: 500;
      color: #666;
      white-space: nowrap;
    `;
    const weight = this.getVariantWeight();
    // Bei Special Tea nur "Stück", sonst "× Gewicht"
    weightSpan.textContent = this.isSpecialTea() ? weight : `× ${weight}`;
    wrapper.appendChild(weightSpan);
    this.weightElement = weightSpan;
  } else {
    this.weightElement = null;
  }
  
  this.appendChild(wrapper);
  
  const hiddenInput = document.createElement('input');
  hiddenInput.type = 'number';
  hiddenInput.name = 'quantity';
  hiddenInput.value = this.myQuantity;
  hiddenInput.min = '1';
  hiddenInput.style.display = 'none';
  hiddenInput.className = 'quantity__input';
  hiddenInput.setAttribute('data-instance', this.instanceId);
  this.appendChild(hiddenInput);
  this.myInput = hiddenInput;
  
  const valueDisplay = this.querySelector('.quantity-value');
  if (valueDisplay) {
    valueDisplay.textContent = this.myQuantity;
  }
  
  setTimeout(() => {
    this.updateMyCartItem();
  }, 50);
  
  if (this.hasVolumeDiscount && this.originalUnitPrice) {
    setTimeout(() => {
      this.updateCartUnitPrice();
    }, 100);
  }
}
      
      updateCartBadge() {
        if (!this.myCartItem) return;
        
        const quantity = parseInt(this.myQuantity);
        
        let discount = 0;
        if (this.hasVolumeDiscount) {
          if (quantity >= 5) discount = 10;
          else if (quantity >= 3) discount = 5;
        }
        
        let rabattBadge = null;
        const allElements = this.myCartItem.querySelectorAll('*');
        for (let elem of allElements) {
          const text = elem.textContent.trim();
          if (text.startsWith('Mengenrabatt Produkt') && elem.children.length === 0) {
            rabattBadge = elem;
            break;
          }
        }
        
        if (rabattBadge && this.hasVolumeDiscount) {
          if (discount > 0) {
            rabattBadge.textContent = `Mengenrabatt Produkt ${discount} %`;
            rabattBadge.style.display = '';
          } else {
            rabattBadge.style.display = 'none';
          }
        }
      }
      
      checkVolumeDiscount() {
        if (this.isCartDrawer) return;
        
        let newHasVolumeDiscount = false;
        
        const directAttribute = this.dataset.hasVolumeDiscount;
        if (directAttribute !== undefined) {
          newHasVolumeDiscount = directAttribute === 'true' || directAttribute === true;
        }
        
        if (!newHasVolumeDiscount && this.productId) {
          const hiddenElement = document.querySelector(`#volume-discount-${this.productId}`);
          if (hiddenElement) {
            const hasDiscount = hiddenElement.dataset.hasVolumeDiscount;
            newHasVolumeDiscount = hasDiscount === 'true' || hasDiscount === true;
          }
        }
        
        if (!newHasVolumeDiscount) {
          const rabattNotiz = this.closest('.product__info-container')?.querySelector('.rabatt-notiz') || null;
          if (rabattNotiz && rabattNotiz.textContent.includes('10% Rabatt')) {
            newHasVolumeDiscount = true;
          }
        }
        
        this.hasVolumeDiscount = newHasVolumeDiscount;
      }
      
      updatePriceDisplay() {
        if (this.isCartDrawer) return;
        if (!this.originalPriceElement || !this.basePrice) return;
        
        const input = this.querySelector('input[type="number"]');
        if (!input) return;
        
        const quantity = parseInt(input.value);
        
        let discount = 0;
        if (this.hasVolumeDiscount) {
          if (quantity >= 5) discount = 10;
          else if (quantity >= 3) discount = 5;
        }
        
        if (discount > 0) {
          const discountedPrice = this.basePrice * (1 - discount / 100);
          const formattedPrice = window.formatMoneyUnified ? 
            window.formatMoneyUnified(Math.round(discountedPrice * 100)) :
            `${discountedPrice.toFixed(2).replace('.', ',')} €`;
          this.originalPriceElement.innerHTML = `${formattedPrice} <small style="color: #ff6b35; font-weight: bold;">(-${discount}%)</small>`;
        } else {
          const formattedPrice = window.formatMoneyUnified ? 
            window.formatMoneyUnified(Math.round(this.basePrice * 100)) :
            this.originalPriceHTML || `${this.basePrice.toFixed(2).replace('.', ',')} €`;
          this.originalPriceElement.innerHTML = formattedPrice;
        }
        
        if (this.originalUnitPriceElement && this.basePricePerKg) {
          if (discount > 0) {
            const discountedPricePerKg = this.basePricePerKg * (1 - discount / 100);
            const formattedUnitPrice = window.formatMoneyUnified ? 
              window.formatMoneyUnified(Math.round(discountedPricePerKg * 100)) :
              `${discountedPricePerKg.toFixed(2).replace('.', ',')} €`;
            this.originalUnitPriceElement.innerHTML = formattedUnitPrice;
          } else {
            const formattedUnitPrice = window.formatMoneyUnified ? 
              window.formatMoneyUnified(Math.round(this.basePricePerKg * 100)) :
              this.originalUnitPriceHTML || `${this.basePricePerKg.toFixed(2).replace('.', ',')} €`;
            this.originalUnitPriceElement.innerHTML = formattedUnitPrice;
          }
        }
      }

      validateQtyRules() {}
      updateQuantityRules(data) {
        if (!data || !data.data) return;
        const { sectionId, productId } = data.data;
        if (sectionId !== this.sectionId || productId !== this.productId) return;
      }
      setQuantityBoundries(data) {
        if (!data || !data.data) return;
        const { sectionId, productId } = data.data;
        if (sectionId !== this.sectionId || productId !== this.productId) return;
      }
    }

    if (!customElements.get('quantity-input')) {
      customElements.define('quantity-input', QuantityInputDropdown);
    }
    
    const style = document.createElement('style');
    style.textContent = `
      .quantity-dropdown-list {
        z-index: 2147483647 !important;
        position: fixed !important;
      }
      
      .quantity-dropdown-list.in-container {
        position: absolute !important;
      }
      
      .quantity-dropdown-container {
        z-index: 999998 !important;
        position: relative !important;
      }
      
      .cart-quantity-wrapper {
        display: inline-flex !important;
        align-items: center !important;
        gap: 8px !important;
      }
      
      .cart-quantity-static {
        display: inline-flex !important;
        align-items: center !important;
        gap: 8px !important;
        font-size: 14px !important;
        color: #666 !important;
        font-weight: 500 !important;
      }
      
      .cart-weight-text {
        display: inline-block !important;
        visibility: visible !important;
        opacity: 1 !important;
        font-size: 14px !important;
        font-weight: 500 !important;
        color: #666 !important;
        white-space: nowrap !important;
      }
      
      .quantity-weight-text {
        display: inline-block !important;
        visibility: visible !important;
        opacity: 1 !important;
        font-size: 16px !important;
        font-weight: 500 !important;
        color: #333 !important;
        white-space: nowrap !important;
      }
      
      quantity-input {
        display: flex !important;
        align-items: center !important;
        overflow: visible !important;
        min-width: 180px !important;
      }
      
      .product-form__quantity {
        overflow: visible !important;
      }
      
      .product-form__buttons,
      .product-form__quantity,
      .product-form,
      .product__info,
      .product-main,
      .sticky-element {
        overflow: visible !important;
        z-index: auto !important;
      }
      
      .product-form__buttons button,
      .product-form__submit,
      .shopify-payment-button {
        z-index: 1 !important;
        position: relative !important;
      }
      
      .quantity-dropdown-toggle:hover {
        border-color: #999 !important;
      }
      
      .quantity-dropdown-toggle:focus {
        outline: 2px solid #000;
        outline-offset: 2px;
      }
      
      .quantity-dropdown-list::-webkit-scrollbar {
        width: 6px;
      }
      
      .quantity-dropdown-list::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 3px;
      }
      
      @media (max-width: 768px) {
        .cart-quantity-wrapper {
          gap: 6px !important;
        }
        
        .quantity-dropdown-container {
          min-width: 70px !important;
        }
        
        .cart-weight-text {
          font-size: 13px !important;
        }
      }
    `;
    document.head.appendChild(style);

  });
});
/* ############################################################################################################## */

/* ===== Pure Tea Block 2 (theme.js 1.8.0, Zeilen 3775-4646) ===== */
document.addEventListener('DOMContentLoaded', function() {
  if (!window.teegartenGoogleMapsLink) return; // Nichts tun, wenn kein Metafeld
  
  document.querySelectorAll('img').forEach(function(img) {
    const src = img.getAttribute('src') || '';
    const alt = img.getAttribute('alt') || '';
    if (/teegarten/i.test(src) || /teegarten/i.test(alt)) {
      // Schon ein Link drum? Dann überspringen
      if (!img.closest('a')) {
        const link = document.createElement('a');
        link.href = window.teegartenGoogleMapsLink;
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        img.parentNode.insertBefore(link, img);
        link.appendChild(img);
      }
    }
  });
});
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('p.product-card__type').forEach(function(typeP) {
    // Typ-Text nach dem <span> auslesen (alle Textknoten nach dem ersten Element)
    let type = '';
    typeP.childNodes.forEach(function(node) {
      if (node.nodeType === 3 && node.textContent.trim()) {
        type += node.textContent.trim();
      }
    });
    if (type) {
      // Text für die Klasse vorbereiten
      let cleanType = type
        .toLowerCase()
        .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
        .replace(/\s+/g, '')  // Leerzeichen entfernen
        .replace(/[^a-z0-9_-]/g, ''); // Sonderzeichen raus

      // Klasse bauen
      let className = 'type-' + cleanType;

      // Klasse auf <p>
      typeP.classList.add(className);

      // Und auf das übergeordnete Element (kannst du ggf. mit .closest('.product-card') anpassen)
      if (typeP.parentElement) {
        typeP.parentElement.classList.add(className);
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", function() {
  var replacements = [
    {
      placeholder: '[[Verpackungsicons]]',
      imageUrl: 'https://cdn.shopify.com/s/files/1/0903/8738/2615/files/pt-packaging-icons.png?v=1752555917',
      cssClass: 'verpackungsicons'
    }
    // ...weitere Platzhalter möglich
  ];

  // Alle passenden Container selektieren!
  var containers = document.querySelectorAll('.metafield-rich_text_field');
  if (!containers.length) return;

  containers.forEach(function(container) {
    replacements.forEach(function(item) {
      // Platzhalter für RegExp escapen
      var escaped = item.placeholder.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp(escaped, 'g');
      var imgTag = '<img src="' + item.imageUrl + '" alt="" class="' + item.cssClass + '" >';
      container.innerHTML = container.innerHTML.replace(regex, imgTag);
    });
  });
});

// TEMPORÄRER FIX - Am Ende der theme.js hinzufügen
if (typeof QuantityInputDropdown !== 'undefined') {
  QuantityInputDropdown.prototype.setupPriceAndWeight = function() {
    const existingDropdown = this.querySelector('.quantity-dropdown-container');
    if (!existingDropdown) return;
    
    const inlineWrapper = document.createElement('div');
    inlineWrapper.className = 'quantity-inline-wrapper';
    inlineWrapper.style.cssText = 'display: flex; align-items: center; gap: 12px;';
    
    const weightSpan = document.createElement('span');
    weightSpan.className = 'quantity-weight';
    weightSpan.style.cssText = 'font-size: 16px; font-weight: 500; color: #000;';
    weightSpan.textContent = 'x 100 g';
    
    inlineWrapper.appendChild(existingDropdown);
    inlineWrapper.appendChild(weightSpan);
    
    this.innerHTML = '';
    this.appendChild(inlineWrapper);
    
    const hiddenInput = document.createElement('input');
    hiddenInput.type = 'number';
    hiddenInput.name = 'quantity';
    hiddenInput.value = '1';
    hiddenInput.min = '1';
    hiddenInput.style.display = 'none';
    this.appendChild(hiddenInput);

  };
  
  QuantityInputDropdown.prototype.setupCartDrawer = function() {
    const existingDropdown = this.querySelector('.quantity-dropdown-container');
    if (existingDropdown) {
      const wrapper = document.createElement('div');
      wrapper.className = 'cart-quantity-wrapper';
      wrapper.appendChild(existingDropdown);
      this.innerHTML = '';
      this.appendChild(wrapper);
    }
  };
}
// Social Media Text zu Icons im Footer ersetzen
(function() {
  // Deine Social Media URLs hier einfügen
  const socialMediaConfig = {
    facebook: {
      url: 'https://www.facebook.com/puretea.de',
      icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" style="vertical-align: middle;">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
      </svg>`
    },
    instagram: {
      url: 'https://www.instagram.com/pureteabio',
      icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" style="vertical-align: middle;">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
      </svg>`
    },
    youtube: {
      url: 'https://www.youtube.com/channel/UCM6Z3S4_0GmLXLyk4yY_8zA',
      icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" style="vertical-align: middle;">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
      </svg>`
    }
  };
  
  function replaceSocialMediaText() {
    // Footer-Element finden
    const footer = document.querySelector('footer');
    
    if (!footer) {
      console.warn('Footer nicht gefunden');
      return;
    }
    
    // Alle Text-Nodes im Footer durchsuchen
    const walker = document.createTreeWalker(
      footer,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );
    
    const nodesToReplace = [];
    let node;
    
    // Regex für alle Social Media Plattformen erstellen
    const platforms = Object.keys(socialMediaConfig).join('|');
    const regex = new RegExp(`(${platforms})`, 'i');
    
    // Erst alle passenden Nodes sammeln
    while (node = walker.nextNode()) {
      const text = node.textContent;
      if (regex.test(text)) {
        nodesToReplace.push(node);
      }
    }
    
    // Dann ersetzen
    nodesToReplace.forEach(node => {
      const parent = node.parentNode;
      let text = node.textContent;
      
      // Container für neue Elemente erstellen
      const container = document.createDocumentFragment();
      let lastIndex = 0;
      
      // Alle Vorkommen finden und ersetzen
      const globalRegex = new RegExp(`(${platforms})`, 'gi');
      let match;
      
      while ((match = globalRegex.exec(text)) !== null) {
        const platform = match[1].toLowerCase();
        const config = socialMediaConfig[platform];
        
        // Text vor dem Match
        if (match.index > lastIndex) {
          container.appendChild(
            document.createTextNode(text.substring(lastIndex, match.index))
          );
        }
        
        // Social Media Icon Link erstellen
        const link = document.createElement('a');
        link.href = config.url;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.title = platform.charAt(0).toUpperCase() + platform.slice(1);
        link.innerHTML = config.icon;
        link.style.cssText = 'display: inline-block; margin: 0 4px; color: inherit; text-decoration: none;';
        
        container.appendChild(link);
        
        lastIndex = match.index + match[0].length;
      }
      
      // Restlichen Text anhängen
      if (lastIndex < text.length) {
        container.appendChild(document.createTextNode(text.substring(lastIndex)));
      }
      
      // Original-Node ersetzen
      parent.replaceChild(container, node);
    });
  }
  
  // Funktion ausführen wenn DOM geladen ist
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', replaceSocialMediaText);
  } else {
    // DOM bereits geladen
    replaceSocialMediaText();
  }
})();
// ============================================================================
// VERBESSERTER ADD-TO-CART INTERCEPTOR - VERSION 2.0
// ============================================================================

(function() {
  'use strict';

  // Debug-Modus (setzen Sie auf false für Production)
  const DEBUG = true;
  
  function debugLog(message, data) {
    if (DEBUG) {
      console.log(`🛒 ADD-TO-CART: ${message}`, data || '');
    }
  }

  // Hilfsfunktion: Prüfe ob Produkt Volume Discount hat
// ERSETZEN Sie die hasVolumeDiscountForProduct Funktion mit dieser Version:

function hasVolumeDiscountForProduct(productId, variantId) {
  console.log('🔍 Suche Volume Discount für:', { productId, variantId });
  
  if (!productId) {
    console.log('❌ Keine Product ID übergeben');
    return false;
  }
  
  // Methode 1: Hidden Element
  const hiddenEl = document.querySelector(`#volume-discount-${productId}`);
  console.log('🔎 Hidden Element Suche:', {
    selector: `#volume-discount-${productId}`,
    found: !!hiddenEl,
    element: hiddenEl,
    hasAttribute: hiddenEl?.hasAttribute('data-has-volume-discount'),
    attributeValue: hiddenEl?.getAttribute('data-has-volume-discount'),
    datasetValue: hiddenEl?.dataset?.hasVolumeDiscount
  });
  
  if (hiddenEl?.dataset.hasVolumeDiscount === 'true') {
    console.log('✅ Volume Discount gefunden via Hidden Element');
    return true;
  }
  
  // Methode 2: quantity-input data-attribute
  const qtyInput = document.querySelector(`quantity-input[data-product-id="${productId}"]`);
  console.log('🔎 Quantity Input Suche:', {
    selector: `quantity-input[data-product-id="${productId}"]`,
    found: !!qtyInput,
    hasAttribute: qtyInput?.hasAttribute('data-has-volume-discount'),
    attributeValue: qtyInput?.getAttribute('data-has-volume-discount'),
    datasetValue: qtyInput?.dataset?.hasVolumeDiscount
  });
  
  if (qtyInput?.dataset.hasVolumeDiscount === 'true') {
    console.log('✅ Volume Discount gefunden via quantity-input');
    return true;
  }
  
  // Methode 3: Suche in allen product-card / quick-buy Containern
  const productCards = document.querySelectorAll(`[data-product-id="${productId}"]`);
  console.log('🔎 Product Cards gefunden:', productCards.length);
  
  for (let card of productCards) {
    const hiddenInCard = card.querySelector(`#volume-discount-${productId}`);
    if (hiddenInCard?.dataset.hasVolumeDiscount === 'true') {
      console.log('✅ Volume Discount gefunden in Product Card');
      return true;
    }
  }
  
  // Methode 4: Rabatt-Notiz auf der Seite
  const rabattNotiz = null; // FIX: globaler Fallback deaktiviert - griff produktuebergreifend (Quick-View)
  console.log('🔎 Rabatt-Notiz gefunden:', {
    found: !!rabattNotiz,
    text: rabattNotiz?.textContent,
    hasRabatt: rabattNotiz?.textContent.includes('10% Rabatt')
  });
  
  if (rabattNotiz && rabattNotiz.textContent.includes('10% Rabatt')) {
    console.log('✅ Volume Discount gefunden via Rabatt-Notiz');
    return true;
  }
  
  // Methode 5: ALLE Hidden Elements auf der Seite anzeigen
  const allHiddenElements = document.querySelectorAll('[id^="volume-discount-"]');
  console.log('🔎 Alle Volume Discount Hidden Elements auf der Seite:', 
    Array.from(allHiddenElements).map(el => ({
      id: el.id,
      productId: el.id.replace('volume-discount-', ''),
      hasVolumeDiscount: el.dataset.hasVolumeDiscount,
      datasetKeys: Object.keys(el.dataset)
    }))
  );
  
  console.log('❌ KEIN Volume Discount gefunden für Product ID:', productId);
  return false;
}

  // Hilfsfunktion: Extrahiere Product ID aus verschiedenen Quellen
  function getProductIdFromContext(form, variantId) {
    // Direkt vom Form
    let productId = form.dataset.productId || 
                   form.getAttribute('data-product-id');
    
    if (productId) return productId;
    
    // Von parent Container
    const container = form.closest('[data-product-id]');
    if (container) {
      productId = container.dataset.productId;
      if (productId) return productId;
    }
    
    // Von quantity-input
    const qtyInput = form.querySelector('quantity-input[data-product-id]');
    if (qtyInput) {
      productId = qtyInput.dataset.productId;
      if (productId) return productId;
    }
    
    // Von hidden input (falls vorhanden)
    const hiddenProductId = form.querySelector('input[name="product-id"]');
    if (hiddenProductId) {
      productId = hiddenProductId.value;
      if (productId) return productId;
    }
    
    // FALLBACK: Suche alle Hidden Elements und prüfe ob Variant zugehörig
    if (variantId) {
      const allHiddenEls = document.querySelectorAll('[id^="volume-discount-"]');
      for (let el of allHiddenEls) {
        const pid = el.id.replace('volume-discount-', '');
        // Prüfe ob diese Product ID die richtige ist (vereinfachte Prüfung)
        if (el.dataset.hasVolumeDiscount === 'true') {
          return pid;
        }
      }
    }
    
    return null;
  }

  // ==========================================================================
  // FORM SUBMIT INTERCEPTOR (für normale Add-to-Cart Forms)
  // ==========================================================================
  document.addEventListener('submit', function(event) {
    const form = event.target;
    
    // Prüfe ob es ein Add-to-Cart Form ist
    if (!form.matches('form[action*="/cart/add"]')) {
      return;
    }

    debugLog('Form Submit erkannt');

    // Hole Variant ID
    const variantInput = form.querySelector('[name="id"]');
    if (!variantInput) {
      debugLog('WARNUNG: Keine Variant ID gefunden');
      return;
    }
    
    const variantId = variantInput.value;
    const productId = getProductIdFromContext(form, variantId);
    
    debugLog('Product/Variant IDs', { productId, variantId });
    
    if (!productId) {
      debugLog('WARNUNG: Keine Product-ID gefunden - kein Property wird hinzugefügt');
      return;
    }

    // Prüfe Volume Discount
    const hasDiscount = hasVolumeDiscountForProduct(productId, variantId);

    // WICHTIG: Füge Property NUR hinzu wenn Discount vorhanden
    // ODER entferne Property explizit wenn keiner vorhanden
    let propertiesInput = form.querySelector('input[name="properties[_volume_discount]"]');
    
    if (hasDiscount) {
      if (!propertiesInput) {
        propertiesInput = document.createElement('input');
        propertiesInput.type = 'hidden';
        propertiesInput.name = 'properties[_volume_discount]';
        form.appendChild(propertiesInput);
      }
      propertiesInput.value = 'true';
      debugLog('✅ Property _volume_discount=true hinzugefügt');
    } else {
      // Entferne Property falls vorhanden
      if (propertiesInput) {
        propertiesInput.remove();
        debugLog('🗑️ Property _volume_discount entfernt');
      }
    }
  }, true); // useCapture = true

  // ==========================================================================
  // FETCH INTERCEPTOR (für AJAX Add-to-Cart wie Quick-Buy)
  // ==========================================================================
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    let [url, options] = args;
    
    // Prüfe ob es ein Add-to-Cart Request ist
    if (url && (url.includes('/cart/add.js') || url.includes('/cart/add'))) {
      debugLog('AJAX Add-to-Cart erkannt', { url });

      try {
        if (options && options.body) {
          let modified = false;
          let bodyData = null;
          let isJSON = false;
          let isFormData = false;
          let isURLEncoded = false;

          // Parse den Body
          if (typeof options.body === 'string') {
            if (options.body.startsWith('{')) {
              // JSON Body
              bodyData = JSON.parse(options.body);
              isJSON = true;
            } else {
              // URL-encoded
              const params = new URLSearchParams(options.body);
              bodyData = Object.fromEntries(params);
              isURLEncoded = true;
            }
          } else if (options.body instanceof FormData) {
            bodyData = Object.fromEntries(options.body);
            isFormData = true;
          }

          if (bodyData && bodyData.id) {
            const variantId = bodyData.id;
            
            // Versuche Product ID zu finden
            let productId = null;
            
            // Methode 1: Aus dem aktuellen Kontext
            const activeProductForm = document.querySelector(`form[action*="/cart/add"] [name="id"][value="${variantId}"]`);
            if (activeProductForm) {
              productId = getProductIdFromContext(activeProductForm.closest('form'), variantId);
            }
            
            // Methode 2: Suche in allen Quick-Buy Buttons
            if (!productId) {
              const quickBuyButtons = document.querySelectorAll('[data-quick-add-button], [data-product-id]');
              for (let btn of quickBuyButtons) {
                const btnProductId = btn.dataset.productId || btn.closest('[data-product-id]')?.dataset.productId;
                if (btnProductId) {
                  productId = btnProductId;
                  break;
                }
              }
            }
            
            // Methode 3: Aus URL Parameters (falls Quick-Buy URL Parameter verwendet)
            if (!productId && url.includes('product_id=')) {
              const urlParams = new URLSearchParams(url.split('?')[1]);
              productId = urlParams.get('product_id');
            }

            debugLog('Product ID für AJAX Request', { productId, variantId });

            if (productId) {
              const hasDiscount = hasVolumeDiscountForProduct(productId, variantId);
              
              // Modifiziere Body basierend auf Discount
              if (hasDiscount) {
                modified = true;
                
                if (isJSON) {
                  bodyData.properties = bodyData.properties || {};
                  bodyData.properties._volume_discount = 'true';
                  options.body = JSON.stringify(bodyData);
                  debugLog('✅ JSON Body modifiziert mit _volume_discount=true');
                } else if (isFormData) {
                  options.body.set('properties[_volume_discount]', 'true');
                  debugLog('✅ FormData modifiziert mit _volume_discount=true');
                } else if (isURLEncoded) {
                  const params = new URLSearchParams(options.body);
                  params.set('properties[_volume_discount]', 'true');
                  options.body = params.toString();
                  debugLog('✅ URL-encoded Body modifiziert mit _volume_discount=true');
                }
              } else {
                // WICHTIG: Entferne Property wenn kein Discount
                if (isJSON && bodyData.properties && bodyData.properties._volume_discount) {
                  delete bodyData.properties._volume_discount;
                  options.body = JSON.stringify(bodyData);
                  modified = true;
                  debugLog('🗑️ JSON: _volume_discount Property entfernt');
                } else if (isFormData && options.body.has('properties[_volume_discount]')) {
                  options.body.delete('properties[_volume_discount]');
                  modified = true;
                  debugLog('🗑️ FormData: _volume_discount Property entfernt');
                } else if (isURLEncoded && options.body.includes('properties[_volume_discount]')) {
                  const params = new URLSearchParams(options.body);
                  params.delete('properties[_volume_discount]');
                  options.body = params.toString();
                  modified = true;
                  debugLog('🗑️ URL-encoded: _volume_discount Property entfernt');
                }
              }
            } else {
              debugLog('⚠️ WARNUNG: Keine Product ID gefunden für AJAX Request');
            }
          }
        }
      } catch (error) {
        console.error('❌ Fehler beim Intercepten des Add-to-Cart Requests:', error);
      }
    }
    
    return originalFetch.apply(this, args);
  };

  debugLog('Add-to-Cart Interceptor v2.0 geladen ✅');
})();

// ==========================================================================
// CART CLEANUP UTILITY
// ==========================================================================
window.consolidateCartItems = async function() {
  console.log('🔧 Starte Cart Cleanup...');
  
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    
    console.log('📦 Cart Items vorher:', cart.items.length);
    
    // Gruppiere Items nach variant_id
    const itemsByVariant = {};
    
    cart.items.forEach((item, index) => {
      const key = item.variant_id;
      if (!itemsByVariant[key]) {
        itemsByVariant[key] = [];
      }
      itemsByVariant[key].push({ item, lineIndex: index + 1 });
    });
    
    // Finde Duplikate
    const duplicates = Object.values(itemsByVariant).filter(items => items.length > 1);
    
    if (duplicates.length === 0) {
      console.log('✅ Keine Duplikate gefunden');
      return;
    }
    
    console.log(`🔍 ${duplicates.length} Duplikat-Gruppe(n) gefunden`);
    
    // Konsolidiere jede Duplikat-Gruppe
    for (let group of duplicates) {
      console.log('Konsolidiere Gruppe:', group);
      
      // Behalte das erste Item, addiere Mengen
      const [first, ...rest] = group;
      const totalQuantity = group.reduce((sum, {item}) => sum + item.quantity, 0);
      
      // Bestimme korrekte Properties
      const hasDiscount = hasVolumeDiscountForProduct(first.item.product_id);
      const properties = hasDiscount ? { _volume_discount: 'true' } : {};
      
      // Update erstes Item mit Gesamtmenge
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          line: first.lineIndex,
          quantity: totalQuantity,
          properties: properties
        })
      });
      
      // Lösche restliche Items
      for (let {lineIndex} of rest) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            line: lineIndex,
            quantity: 0
          })
        });
      }
    }
    
    console.log('✅ Cart Cleanup abgeschlossen');
    
    // Refresh Cart
    window.location.reload();
    
  } catch (error) {
    console.error('❌ Cart Cleanup Fehler:', error);
  }
};

// Helper function für Volume Discount Check
function hasVolumeDiscountForProduct(productId) {
  if (!productId) return false;
  const hiddenEl = document.querySelector(`#volume-discount-${productId}`);
  return hiddenEl?.dataset.hasVolumeDiscount === 'true';
}

console.log('🎯 Cart Consolidation Utility geladen. Rufe window.consolidateCartItems() auf um Duplikate zu bereinigen.');

// Migration für bestehende Cart Items
window.migrateExistingCartItems = async function() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    
    for (let i = 0; i < cart.items.length; i++) {
      const item = cart.items[i];
      
      if (item.properties?._volume_discount) continue;
      
      const hiddenEl = document.querySelector(`#volume-discount-${item.product_id}`);
      if (hiddenEl?.dataset.hasVolumeDiscount === 'true') {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            line: i + 1,
            quantity: item.quantity,
            properties: { ...item.properties, _volume_discount: 'true' }
          })
        });
      }
    }
  } catch (error) {
    console.error('Migration Fehler:', error);
  }
};

document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', (e) => {
    const closeBtn = e.target.closest('.drawer__close-btn');
    const overlay = e.target.closest('.fixed-overlay');
    
    if (closeBtn || overlay) {
      document.body.classList.remove('modal-show');
      document.body.style.overflow = '';
    }
  });
});

document.addEventListener('DOMContentLoaded', function() {
  // Prüfen ob wir auf der richtigen Seite sind
  if (window.location.pathname.includes('/collections/tee-probieren')) {
    const buttons = document.querySelectorAll('.product-card__action-button');
    buttons.forEach(button => {
      button.style.display = 'none';
    });
  }
});

// Green Weekend Badge Text ändern
document.addEventListener('DOMContentLoaded', function() {
  const saleBadges = document.querySelectorAll('.f-badge--sale');
  
  saleBadges.forEach(function(badge) {
    const saleValue = badge.querySelector('[data-sale-value]');
    if (saleValue) {
      badge.innerHTML = 'Spare jetzt <span data-sale-value="">' + saleValue.textContent + '</span>';
    }
  });
});

// Crossed-out für Sale-Preise - KORREKTER SELEKTOR
document.addEventListener('DOMContentLoaded', function() {
  // Nur das .f-price-item--regular INNERHALB von .f-price__sale durchstreichen
  document.querySelectorAll('.f-price__sale .f-price-item--regular').forEach(function(el) {
    el.classList.add('crossed-out');
  });
});

(function() {
  console.log('🍪 Cookiebot Reload Script gestartet');
  
  const buttonIds = [
    'CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll',
    'CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelection',
    'CybotCookiebotDialogBodyButtonDecline'
  ];

  function attachListeners() {
    let attached = 0;
    buttonIds.forEach(function(id) {
      const btn = document.getElementById(id);
      if (btn && !btn.hasAttribute('data-reload-attached')) {
        btn.setAttribute('data-reload-attached', 'true');
        btn.addEventListener('click', function() {
          //console.log('🍪 Button geklickt:', id);
          setTimeout(function() {
            //console.log('🍪 Reload wird ausgeführt...');
            window.location.reload();
          }, 500);
        });
        attached++;
        //console.log('🍪 Listener attached zu:', id);
      }
    });
    return attached;
  }

  // Sofort versuchen
  attachListeners();

  // Auf Cookiebot Event warten
  window.addEventListener('CookiebotOnDialogDisplay', function() {
    //console.log('🍪 CookiebotOnDialogDisplay Event gefeuert');
    setTimeout(attachListeners, 100);
  });

  // Fallback: MutationObserver für dynamisch geladenen Banner
  const observer = new MutationObserver(function(mutations) {
    if (document.getElementById('CybotCookiebotDialog')) {
      //console.log('🍪 Banner via MutationObserver erkannt');
      setTimeout(attachListeners, 100);
    }
  });
  
  observer.observe(document.body, { childList: true, subtree: true });

  // Cleanup nach 30 Sekunden
  setTimeout(function() {
    observer.disconnect();
    //console.log('🍪 MutationObserver gestoppt');
  }, 30000);
})();
/* ===== FIX 1 (KORRIGIERT): Mengen-Dropdown bleibt beim Scrollen am Feld ===== */
customElements.whenDefined('quantity-input').then(function () {
  const Ctor = customElements.get('quantity-input');
  if (!Ctor) return;

  Ctor.prototype.openDropdown = function () {
    if (this._repositionDropdown) {
      window.removeEventListener('scroll', this._repositionDropdown, { capture: true });
      window.removeEventListener('resize', this._repositionDropdown);
    }
    this.dropdownList.style.display = 'block';
    this.selectedDisplay.setAttribute('aria-expanded', 'true');
    document.body.appendChild(this.dropdownList);

    const reposition = () => {
      const rect = this.selectedDisplay.getBoundingClientRect();
      this.dropdownList.style.position = 'fixed';
      this.dropdownList.style.top = (rect.bottom + 4) + 'px';
      this.dropdownList.style.left = rect.left + 'px';
      this.dropdownList.style.zIndex = '2147483647';
    };
    reposition();
    this._repositionDropdown = reposition;
    window.addEventListener('scroll', reposition, { passive: true, capture: true });
    window.addEventListener('resize', reposition, { passive: true });
  };

  Ctor.prototype.closeDropdown = function () {
    this.dropdownList.style.display = 'none';
    this.selectedDisplay.setAttribute('aria-expanded', 'false');
    if (this._repositionDropdown) {
      window.removeEventListener('scroll', this._repositionDropdown, { capture: true });
      window.removeEventListener('resize', this._repositionDropdown);
      this._repositionDropdown = null;
    }
    const container = this.querySelector('.quantity-dropdown-container');
    if (container && this.dropdownList.parentElement === document.body) {
      this.dropdownList.style.position = 'absolute';
      this.dropdownList.style.top = '100%';
      this.dropdownList.style.left = '0';
      container.appendChild(this.dropdownList);
    }
  };
});
/* ===== FIX 2: Rabatt-Badge (-5% / -10%) bleibt stabil ===== */
(function () {
  function initBadgeGuard() {
    const priceBlock = document.querySelector('.product__block--price');
    if (!priceBlock) return; // nur auf Produktseiten

    const discountFor = q => (q >= 5 ? 10 : q >= 3 ? 5 : 0);
    const fmt = cents => (window.formatMoneyUnified
      ? window.formatMoneyUnified(cents)
      : (cents / 100).toFixed(2).replace('.', ',') + ' €');

    // Haupt-Instanz (Kaufformular) mit gültigem Basispreis finden
    const mainQI = () => Array.from(document.querySelectorAll('quantity-input'))
      .find(q => q.basePrice > 0);

    let writing = false;
    function enforce() {
      if (writing) return;
      const qi = mainQI();
      if (!qi) return;
      const base = qi.basePrice;
      const qty = parseInt((qi.querySelector('input[type="number"]') || {}).value || '1', 10) || 1;
      const el = priceBlock.querySelector('.f-price-item--regular');
      if (!el) return;

      const _pid = qi.getAttribute('data-product-id'); const _vdEl = _pid ? document.querySelector('#volume-discount-' + _pid) : null; const d = (_vdEl && _vdEl.dataset.hasVolumeDiscount === 'true') ? discountFor(qty) : 0;
      if (d > 0) {
        // Badge muss vorhanden sein – falls nicht, korrekt wiederherstellen
        if (el.innerHTML.indexOf('(-' + d + '%)') === -1) {
          writing = true;
          el.innerHTML = fmt(Math.round(base * (1 - d / 100) * 100)) +
            ' <small style="color: #ff6b35; font-weight: bold;">(-' + d + '%)</small>';
          writing = false;
        }
      } else {
        // keine Rabattmenge -> kein Badge
        if (el.querySelector('small')) {
          writing = true;
          el.innerHTML = fmt(Math.round(base * 100));
          writing = false;
        }
      }
    }

    // Bei jeder Änderung der Preiszeile prüfen und ggf. wiederherstellen
    new MutationObserver(function () { enforce(); })
      .observe(priceBlock, { childList: true, subtree: true, characterData: true });

    // zusätzlich bei Mengenwechsel
    document.addEventListener('change', function () { setTimeout(enforce, 0); }, true);
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.quantity-option, .quantity-dropdown-toggle')) {
        setTimeout(enforce, 0);
      }
    }, true);

    enforce();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBadgeGuard);
  } else {
    initBadgeGuard();
  }
})();

/* ===== Pure Tea: Cart-Drawer-Hooks (in Sleek 1.8.0 direkt in der CartDrawer-Klasse von cart.js) ===== */
(function () {
  const SHIPPING_COST = 490; // 4,90 EUR in Cent – Wert aus cart.js 1.8.0 (CartDrawer.SHIPPING_COST)

  function updateShippingDisplay(event) {
    if (!event.detail || !event.detail.cart) return;
    const cartTotal = event.detail.cart.total_price || 0;
    const totalElement = document.getElementById('cart-total-with-shipping');
    if (totalElement && window.formatMoneyUnified) {
      totalElement.textContent = window.formatMoneyUnified(cartTotal + SHIPPING_COST);
    }
  }
  document.addEventListener('cart:updated', updateShippingDisplay);

  function bindOverlay() {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer || drawer._overlayListenerAdded) return;
    const overlay = drawer.querySelector('.fixed-overlay');
    if (!overlay) return;
    overlay.addEventListener('click', (event) => {
      if (event.target === overlay && typeof drawer.hide === 'function') drawer.hide();
    });
    drawer._overlayListenerAdded = true;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindOverlay);
  else bindOverlay();
})();

/* ===== Pure Tea: Konto-Overlay (<shopify-account>, neu in Sleek 2.3.0) ===== */
(function () {
  // 1) Vendor-Race: header.js (HeaderAccount.connectedCallback) injiziert seine Overlay-Styles nur einmal beim Laden;
  //    ist das shadowRoot der Komponente dann noch nicht vorhanden, bleibt das Overlay unformatiert (transparent, volle Höhe).
  //    Hier wird die (idempotente) Vendor-Methode injectAnimation nachgezogen, sobald die Komponente bereit ist.
  // 2) Schnell-Links "Bestellungen"/"Profil" NUR im ausgeloggten Zustand ausblenden (Kundenwunsch). Kriterium: im Overlay
  //    ist das Login-Formular (shopify-login-form / shop-login) vorhanden. Eingeloggt (kein Login-Formular) bleibt das
  //    Kontomenü sichtbar; ein MutationObserver reagiert auf Login/Logout direkt im Overlay.
  var STYLE_ID = 'puretea-account-styles';
  var HIDE_CSS = '.account__menu-region { display: none !important; }';

  function isSignedOut(shadow) {
    // beide Bedingungen: Liquid hat den Ausgeloggt-Avatar gerendert (kein customer) UND das Login-Formular ist im Overlay
    var host = shadow.host;
    var liquidSignedOut = !!(host && host.querySelector('[slot="signed-out-avatar"]'));
    var loginForm = !!shadow.querySelector('shopify-login-form, shop-login');
    return liquidSignedOut && loginForm;
  }
  function syncQuickLinks(shadow) {
    var st = shadow.getElementById ? shadow.getElementById(STYLE_ID) : shadow.querySelector('#' + STYLE_ID);
    if (isSignedOut(shadow)) {
      if (!st) { st = document.createElement('style'); st.id = STYLE_ID; st.textContent = HIDE_CSS; shadow.appendChild(st); }
    } else if (st) {
      st.remove();
    }
  }
  function apply() {
    document.querySelectorAll('header-account').forEach(function (ha) {
      var acc = ha.querySelector('shopify-account');
      if (!acc || !acc.shadowRoot) return;
      if (typeof ha.injectAnimation === 'function') ha.injectAnimation(acc);
      var shadow = acc.shadowRoot;
      syncQuickLinks(shadow);
      if (!shadow.__pureteaObserved) {
        shadow.__pureteaObserved = true;
        var pending = null;
        new MutationObserver(function () {
          if (pending) return;
          pending = setTimeout(function () { pending = null; syncQuickLinks(shadow); }, 50);
        }).observe(shadow, { childList: true, subtree: true });
      }
    });
  }
  function start() {
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      var acc = document.querySelector('header-account shopify-account');
      if (acc && acc.shadowRoot) { apply(); clearInterval(timer); }
      else if (tries > 100) clearInterval(timer); // max. 10 s
    }, 100);
  }
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('shopify-account').then(start);
    customElements.whenDefined('header-account').then(start);
  } else { start(); }
})();

/* ===== Pure Tea Block 3 (cart.js 1.8.0, Zeilen 714-1029) ===== */
// GLOBALE EINHEITLICHE PREISFORMATIERUNG
window.formatMoneyUnified = function(cents) {
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    currencyDisplay: 'symbol'
  }).format(cents / 100);
};

// Versandkosten Utility Klasse mit einheitlicher Preisformatierung
class CartShippingCalculator {
  constructor() {
    this.isCalculating = false;
    this.currentShippingCost = 0;
    this.shippingData = window.cartShippingData || {};
    this.FALLBACK_SHIPPING = 425;
    this.init();
  }

  init() {
    // Warten bis DOM und cartShippingData verfügbar
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(() => this.calculateShipping(), 500);
      });
    } else {
      setTimeout(() => this.calculateShipping(), 500);
    }
    
    // Event Listener für Cart Changes
    document.addEventListener('cart:updated', (event) => {
      setTimeout(() => {
        this.calculateShipping(event.detail.cart);
        this.unifyAllPriceFormats();
      }, 100);
    });
  }

  async calculateShipping(cart = null) {
    if (this.isCalculating || !this.shippingData.routes) return;
    
    this.isCalculating = true;
    this.showLoadingState();

    try {
      // Cart Daten holen falls nicht übergeben
      if (!cart) {
        const response = await fetch(`${this.shippingData.routes.cartUrl}.js`);
        cart = await response.json();
      }

      // Länderspezifische Free Shipping Schwellenwerte
      const cartTotalEuro = cart.total_price / 100;
      const customerCountry = this.shippingData.customer.defaultAddress.countryCode || 'DE';
      
      let freeShippingThresholdEuro;
      if (customerCountry === 'DE') {
        freeShippingThresholdEuro = 39; // Deutschland: 39€
      } else {
        freeShippingThresholdEuro = 100; // Andere Länder: 100€
      }

      if (cartTotalEuro >= freeShippingThresholdEuro) {
        this.displayFreeShipping();
        this.updateTotal(cart.total_price, 0);
        return;
      }

      // Standard-Versandkosten
      this.displayStandardShipping();
      this.updateTotal(cart.total_price, this.FALLBACK_SHIPPING / 100);

    } catch (error) {
      console.error('Shipping calculation error:', error);
      this.displayStandardShipping();
      this.updateTotal();
    } finally {
      this.isCalculating = false;
      // Preise nach Berechnung vereinheitlichen
      setTimeout(() => {
        this.unifyAllPriceFormats();
      }, 200);
    }
  }

  showLoadingState() {
    const label = document.getElementById('shipping-label');
    const cost = document.getElementById('shipping-cost-display');
    
    if (label) {
      label.innerHTML = '<span class="cart-drawer__shipping-loading">Versandkosten werden berechnet...</span>';
    }
    if (cost) {
      cost.textContent = '...';
    }
  }

  displayFreeShipping() {
    const label = document.getElementById('shipping-label');
    const cost = document.getElementById('shipping-cost-display');
    
    if (label) {
      label.textContent = 'Kostenloser Versand';
    }
    if (cost) {
      cost.textContent = window.formatMoneyUnified(0);
    }
    
    this.currentShippingCost = 0;
  }

  displayStandardShipping() {
    const label = document.getElementById('shipping-label');
    const cost = document.getElementById('shipping-cost-display');
    
    if (label) {
      label.textContent = 'Versand (Standard Deutschland)';
    }
    if (cost) {
      cost.textContent = window.formatMoneyUnified(this.FALLBACK_SHIPPING);
    }
    
    this.currentShippingCost = this.FALLBACK_SHIPPING;
  }

  updateTotal(cartTotal = null, shippingCost = null) {
    // Aktuelle Cart-Summe ermitteln
    if (cartTotal === null) {
      const subtotalElement = document.querySelector('.totals__subtotal-value');
      if (subtotalElement) {
        const cents = this.extractCentsFromText(subtotalElement.textContent);
        cartTotal = cents || 0;
      }
    }
    
    // Shipping Cost in Cents
    if (shippingCost === null) {
      shippingCost = this.currentShippingCost / 100;
    }
    
    const totalElement = document.getElementById('cart-total-with-shipping');
    const shippingInCents = shippingCost * 100;
    const totalWithShipping = cartTotal + shippingInCents;
    
    if (totalElement) {
      totalElement.textContent = window.formatMoneyUnified(totalWithShipping);
    }

    // Alle Preise einheitlich formatieren
    setTimeout(() => {
      this.unifyAllPriceFormats();
    }, 50);
  }

  // Alle Preise im Cart Drawer einheitlich formatieren
  unifyAllPriceFormats() {
    const priceSelectors = [
      '.totals__subtotal-value',     // Zwischensumme
      '.totals__total-value',        // Gesamtsumme
      '.cart-item__total-price',     // Einzelpreis pro Artikel
      '.price__regular',             // Regulärer Preis
      '.price__sale',                // Sale Preis
      '.f-price-item--regular',      // Theme-spezifische Preise
      '.f-price-item--sale',         // Theme-spezifische Sale-Preise
      '.cart-drawer__shipping-cost', // Versandkosten
      '#shipping-cost-display'       // Versandkosten Display
    ];

    priceSelectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        const currentText = element.textContent.trim();
        
        // Nur formatieren wenn es ein Preis ist
        if (this.isPriceText(currentText)) {
          const cents = this.extractCentsFromText(currentText);
          if (!isNaN(cents) && cents >= 0) {
            element.textContent = window.formatMoneyUnified(cents);
          }
        }
      });
    });

    // Trigger Event für Quantity Dropdown Script
    document.dispatchEvent(new CustomEvent('priceFormatUpdate', {
      detail: { source: 'cart-shipping-calculator' }
    }));
  }

  // Prüfen ob Text ein Preis ist
  isPriceText(text) {
    return text.includes('€') || 
           text.includes(',') || 
           /^\d+[\.,]\d{2}$/.test(text) ||
           /^\d+$/.test(text) ||
           text === '0' ||
           text === '0,00';
  }

  // Cents aus Text extrahieren
  extractCentsFromText(text) {
    // Spezialfall für "0" oder "0,00"
    if (text === '0' || text === '0,00' || text === '€0,00' || text === '0,00 €') {
      return 0;
    }
    
    // Entferne alle Nicht-Zahlen-Zeichen außer Komma und Punkt
    const cleanText = text.replace(/[^0-9,\.]/g, '');
    
    // Handle verschiedene Formate
    if (cleanText.includes(',')) {
      // Deutsche Format: 10,50 oder 1.234,50
      const parts = cleanText.split(',');
      if (parts.length === 2) {
        const euros = parseInt(parts[0].replace(/\./g, '')) || 0; // Entferne Tausendertrennzeichen
        const cents = parseInt(parts[1].padEnd(2, '0').substring(0, 2)) || 0;
        return euros * 100 + cents;
      }
    } else if (cleanText.includes('.')) {
      // Amerikanisches Format: 10.50 (nur wenn ein Punkt vorhanden)
      const parts = cleanText.split('.');
      if (parts.length === 2 && parts[1].length <= 2) {
        const euros = parseInt(parts[0]) || 0;
        const cents = parseInt(parts[1].padEnd(2, '0')) || 0;
        return euros * 100 + cents;
      }
    } else {
      // Nur Euros ohne Cent-Angabe
      const euros = parseInt(cleanText) || 0;
      return euros * 100;
    }
    
    return 0;
  }
}

// Initialisierung der Versandkosten-Berechnung
window.cartShippingCalculator = new CartShippingCalculator();

// Observer für dynamische Änderungen im Cart Drawer
document.addEventListener('DOMContentLoaded', () => {
  const cartDrawer = document.querySelector('cart-drawer, #CartDrawer');
  if (cartDrawer) {
    const observer = new MutationObserver((mutations) => {
      let shouldUpdate = false;
      
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          const addedNodes = Array.from(mutation.addedNodes);
          const hasNewPrices = addedNodes.some(node => 
            node.nodeType === 1 && 
            (node.querySelector && node.querySelector('[class*="price"], [class*="total"]') ||
             node.className && node.className.includes('price'))
          );
          
          if (hasNewPrices || (mutation.target.className && mutation.target.className.includes('price'))) {
            shouldUpdate = true;
          }
        }
      });
      
      if (shouldUpdate && window.cartShippingCalculator) {
        setTimeout(() => {
          window.cartShippingCalculator.unifyAllPriceFormats();
        }, 100);
      }
    });
    
    observer.observe(cartDrawer, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
});

// FoxTheme Currency Formatierung überschreiben für Konsistenz
if (typeof FoxTheme !== 'undefined' && FoxTheme.Currency) {
  FoxTheme.Currency.formatMoney = function(cents, format) {
    return window.formatMoneyUnified(cents);
  };
}

window.FoxKitAddToCart = async (payload) => {
  if (!payload?.properties?.['_FoxKit offer']) return;

  const cartJson = await (
    await fetch(`${FoxTheme.routes.cart_url}`, {
      ...FoxTheme.utils.fetchConfig(),
    })
  ).json();
  cartJson['sections'] = payload['sections'];
  FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });

  document.dispatchEvent(
    new CustomEvent('product-ajax:added', {
      detail: {
        product: payload,
      },
    })
  );
};

// Event Delegation für Continue Shopping Button
document.addEventListener('click', function(event) {
  // Prüfen ob der geklickte Link der "Continue Shopping" Button ist
  if (event.target.matches('.cart-drawer__empty a[href="/collections/all"]')) {
    event.preventDefault();
    
    // Cart Drawer finden und schließen
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && cartDrawer.hide) {
      cartDrawer.hide();
    }
  }
});
